import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { Checkbox, DateString, NonNegativeMonetaryValue } from '../fields';

export const InvestorSplit = z.enum(['servicer', 'investor', 'fiftyFifty']);

export const RecordDrawDisbursementRow = z.object({
  loanId: LosId,
  disbursementType: z.enum(['approvedDraw']),
  disbursementDate: DateString,
  disbursementTotal: NonNegativeMonetaryValue,
  drawFee: NonNegativeMonetaryValue.optional(),
  deferFee: Checkbox.default(true),
  investorSplit: InvestorSplit.default('servicer'),
  note: z.string().optional(),
  regenerateStatementIncludingDraw: z.boolean().optional(),
});

export const RECORD_DRAW_DISBURSEMENT_ROW_REQUIRED_FIELDS = Object.keys(RecordDrawDisbursementRow.shape).filter(
  (key) => !RecordDrawDisbursementRow.shape[key as keyof typeof RecordDrawDisbursementRow.shape].isOptional(),
);
